<script lang="ts">
    import { countryIndex } from 'wdom/services/country_data'

    import type { IAddress, IContact } from 'wdom/services/contacts'

    interface Props {
        contact: IContact | IAddress;
    }

    let { contact }: Props = $props();

    let visual: string = $derived(contact.country != null && $countryIndex != null && $countryIndex[contact.country] != null ? $countryIndex[contact.country] : null)
    
</script>

{#if visual}{visual}{/if}
